import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player/lazy';
import PromptModal from '@wix/da-ds/pkg/modals/dsPresets/PromptModal';

interface Props {
  onSubmit: (inputValue?: string) => void;
  onCancel: () => void;
}

const DaVideoPopup: React.FC<Props> = ({ onSubmit, onCancel }) => {
  const { t } = useTranslation('editor');

  const validateInput = (value: string) => {
    return !ReactPlayer.canPlay(value)
      ? t('ext.video.modal.input.error')
      : undefined;
  };

  return (
    <PromptModal
      isOpen
      title={t('ext.video.modal.title')}
      inputLabel={t('ext.video.modal.input.label')}
      inputPlaceholder={t('ext.video.modal.input.placeholder')}
      onInputValidate={validateInput}
      onCancel={onCancel}
      onDone={onSubmit}
      minLength={1}
    />
  );
};
DaVideoPopup.displayName = 'DaVideoPopup';

export default DaVideoPopup;
